import { NC, LOGO_URL } from "../landing/shared";

export default function LegalLayout({ title, updated, children, testId }) {
  return (
    <div className="min-h-screen bg-grid-80" data-testid={testId}>
      <header className="border-b border-white/10">
        <div className="max-w-3xl mx-auto px-6 py-5 flex items-center justify-between">
          <a href="/" className="flex items-center gap-3" data-testid={`${testId}-home-link`}>
            <img src={LOGO_URL} alt="Shoreline Mortgage Group" className="h-9 w-auto bg-white/90 p-1" />
          </a>
          <a href="/" className="font-mono-strict text-[11px] tracking-[0.2em] text-white/50 hover:text-white transition-colors duration-200">
            ← BACK TO SITE
          </a>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-14">
        <p className="font-mono-strict text-[11px] tracking-[0.3em] text-[#0162CA] mb-4 uppercase">
          SHORELINE MORTGAGE GROUP · VA BETTER-BUY MASTERCLASS™
        </p>
        <h1 className="font-black uppercase tracking-tight text-3xl md:text-5xl mb-3">{title}</h1>
        <p className="font-mono-strict text-[11px] tracking-[0.15em] text-white/35 mb-12">LAST UPDATED: {updated}</p>
        <div className="space-y-10">{children}</div>
        <div className="mt-16 border-t border-white/10 pt-8 text-[11px] text-white/35 leading-relaxed">
          <p>
            Questions about this document? Contact Shoreline Mortgage Group — Phone: <NC label="PHONE" /> · Email:{" "}
            <NC label="EMAIL" /> · Mailing address: <NC label="BRANCH ADDRESS" />
          </p>
          <p className="font-mono-strict tracking-[0.2em] text-white/20 mt-6">
            © 2026 SHORELINE MORTGAGE GROUP
          </p>
        </div>
      </main>
    </div>
  );
}

export const LegalSection = ({ n, title, children }) => (
  <section>
    <h2 className="font-bold uppercase tracking-wide text-lg mb-3">
      <span className="font-mono-strict text-[#0162CA] text-sm mr-3">{n}</span>
      {title}
    </h2>
    <div className="text-white/60 text-[14px] leading-[1.85] space-y-3 pl-0 md:pl-10">{children}</div>
  </section>
);
